(function () {
  'use strict';
  if (window.__kmBlogHeroCarouselLoaded) return;
  window.__kmBlogHeroCarouselLoaded = true;
  var instances = new WeakMap();
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');

  function applyHighlights(slide) {
    var body = slide.querySelector('[data-km-body]');
    if (!body || body.dataset.kmHighlighted === 'true') return;
    body.dataset.kmHighlighted = 'true';
    var phrases = (slide.getAttribute('data-highlight-phrases') || '')
      .split(/\r?\n/).map(function (phrase) { return phrase.trim(); }).filter(Boolean);
    if (!phrases.length) return;

    var escaped = phrases.map(function (phrase) {
      return phrase.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    });
    var matcher = new RegExp(escaped.join('|'), 'gi');
    var walker = document.createTreeWalker(body, NodeFilter.SHOW_TEXT, {
      acceptNode: function (node) {
        if (!node.nodeValue || !node.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
        var parent = node.parentElement;
        if (!parent || parent.closest('a, script, style, .km-blog-hero__highlight, [data-km-no-highlight]')) {
          return NodeFilter.FILTER_REJECT;
        }
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (textNode) {
      matcher.lastIndex = 0;
      if (!matcher.test(textNode.nodeValue)) return;
      matcher.lastIndex = 0;
      var fragment = document.createDocumentFragment();
      var value = textNode.nodeValue;
      var cursor = 0;
      var match;
      while ((match = matcher.exec(value)) !== null) {
        if (match.index > cursor) fragment.appendChild(document.createTextNode(value.slice(cursor, match.index)));
        var mark = document.createElement('span');
        mark.className = 'km-blog-hero__highlight';
        mark.style.setProperty('--km-highlight', slide.getAttribute('data-highlight-color') || '#df6469');
        if (slide.getAttribute('data-highlight-bold') === 'true') mark.style.fontWeight = '700';
        mark.textContent = match[0];
        fragment.appendChild(mark);
        cursor = match.index + match[0].length;
        if (!match[0].length) matcher.lastIndex++;
      }
      if (cursor < value.length) fragment.appendChild(document.createTextNode(value.slice(cursor)));
      textNode.parentNode.replaceChild(fragment, textNode);
    });
  }

  function init(section) {
    if (!section || instances.has(section)) return;
    var slides = Array.prototype.slice.call(section.querySelectorAll('[data-km-slide]'));
    slides.forEach(applyHighlights);
    if (slides.length < 2) return;
    var dots = Array.prototype.slice.call(section.querySelectorAll('[data-km-dot]'));
    var previous = section.querySelector('[data-km-prev]');
    var next = section.querySelector('[data-km-next]');
    var toggle = section.querySelector('[data-km-toggle]');
    var status = section.querySelector('[data-km-status]');
    var index = Math.max(0, slides.findIndex(function (slide) { return slide.classList.contains('is-active'); }));
    var timer = null;
    var stopped = false;
    var hovering = false;
    var focused = false;
    var editorMode = !!(window.Shopify && window.Shopify.designMode);
    var duration = Math.min(20000, Math.max(2000, Number(section.dataset.interval) || 5000));
    var autoplayEnabled = section.dataset.autoplay === 'true';
    var initialAutoPlayAllowed = (!editorMode || section.dataset.editorAutoplay !== 'false') && !(reducedMotion && reducedMotion.matches);
    var userStarted = false;
    var editorSelected = false;
    var transition = null;

    function finishTransition() {
      if (!transition) return;
      var current = transition;
      transition = null;
      current.animations.forEach(function (animation) { animation.cancel(); });
      current.outgoing.hidden = true;
      current.outgoing.style.position = current.position;
      current.outgoing.style.inset = current.inset;
      current.outgoing.style.width = current.width;
      current.outgoing.inert = current.inert;
    }

    stopped = !initialAutoPlayAllowed;
    if (toggle) {
      toggle.setAttribute('aria-pressed', String(stopped));
      toggle.setAttribute('aria-label', stopped ? 'Play slide autoplay' : 'Pause slide autoplay');
    }

    function paint(nextIndex, announce, animate) {
      finishTransition();
      var oldIndex = index;
      var direction = nextIndex < oldIndex ? -1 : 1;
      index = (nextIndex + slides.length) % slides.length;
      var outgoing = slides[oldIndex];
      var incoming = slides[index];
      var moving = animate !== false && oldIndex !== index && incoming.animate &&
        !(reducedMotion && reducedMotion.matches);
      slides.forEach(function (slide, slideIndex) {
        var active = slideIndex === index;
        slide.hidden = !active && !(moving && slide === outgoing);
        slide.classList.toggle('is-active', active);
        if (active) slide.removeAttribute('aria-hidden');
        else slide.setAttribute('aria-hidden', 'true');
      });
      if (moving) {
        var state = { outgoing: outgoing, position: outgoing.style.position,
          inset: outgoing.style.inset, width: outgoing.style.width,
          inert: outgoing.inert, animations: [] };
        outgoing.style.position = 'absolute';
        outgoing.style.inset = '0';
        outgoing.style.width = '100%';
        outgoing.inert = true;
        var timing = { duration: 600, easing: 'cubic-bezier(.22,.61,.36,1)', fill: 'both' };
        state.animations = [
          outgoing.animate([{transform:'translateX(0)'},{transform:'translateX(' + (-direction * 100) + '%)'}], timing),
          incoming.animate([{transform:'translateX(' + (direction * 100) + '%)'},{transform:'translateX(0)'}], timing)
        ];
        transition = state;
        state.animations[0].finished.catch(function () {});
        state.animations[1].finished.then(function () {
          if (transition === state) finishTransition();
        }).catch(function () {});
      }
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
      if (announce && status) status.textContent = 'Slide ' + (index + 1) + ' of ' + slides.length;
    }

    function clearTimer() {
      if (timer !== null) window.clearInterval(timer);
      timer = null;
    }
    function startTimer() {
      clearTimer();
      if (!autoplayEnabled || stopped || editorSelected || (!initialAutoPlayAllowed && !userStarted) || ((hovering || focused) && !userStarted) || document.hidden) return;
      timer = window.setInterval(function () { paint(index + 1, false); }, duration);
    }
    function manualMove(newIndex) {
      paint(newIndex, true);
      if (autoplayEnabled && !stopped) startTimer();
    }
    function onPrev() { manualMove(index - 1); }
    function onNext() { manualMove(index + 1); }
    function onToggle() {
      stopped = editorSelected ? false : !stopped;
      editorSelected = false;
      userStarted = !stopped;
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(stopped));
        toggle.setAttribute('aria-label', stopped ? 'Play slide autoplay' : 'Pause slide autoplay');
      }
      if (stopped) clearTimer();
      else startTimer();
    }
    function onEnter() { hovering = true; if (!userStarted) clearTimer(); }
    function onLeave() { hovering = false; startTimer(); }
    function onFocusIn() { focused = true; if (!userStarted) clearTimer(); }
    function onFocusOut(event) {
      if (!section.contains(event.relatedTarget)) { focused = false; startTimer(); }
    }
    function onVisibility() { if (document.hidden) clearTimer(); else startTimer(); }
    function onKeydown(event) {
      if (event.target.closest('a, button, input, select, textarea')) return;
      if (event.key === 'ArrowLeft') { event.preventDefault(); onPrev(); }
      if (event.key === 'ArrowRight') { event.preventDefault(); onNext(); }
      if (autoplayEnabled && (event.key === ' ' || event.key === 'Spacebar')) {
        event.preventDefault(); onToggle();
      }
      if (autoplayEnabled && event.key === 'Escape') {
        event.preventDefault();
        if (!stopped || editorSelected) { editorSelected = false; stopped = false; onToggle(); }
      }
    }
    function onBlockSelect(event) {
      var selected = event.target.closest('[data-km-slide]');
      if (!selected || !section.contains(selected)) return;
      editorSelected = true;
      clearTimer();
      if (toggle) {
        toggle.setAttribute('aria-pressed', 'true');
        toggle.setAttribute('aria-label', 'Play slide autoplay');
      }
      paint(slides.indexOf(selected), false, false);
    }
    function onBlockDeselect(event) {
      var selected = event.target.closest('[data-km-slide]');
      if (!selected || !section.contains(selected)) return;
      editorSelected = false;
      if (toggle) {
        toggle.setAttribute('aria-pressed', String(stopped));
        toggle.setAttribute('aria-label', stopped ? 'Play slide autoplay' : 'Pause slide autoplay');
      }
      startTimer();
    }
    function destroy() {
      clearTimer();
      finishTransition();
      section.removeEventListener('mouseenter', onEnter);
      section.removeEventListener('mouseleave', onLeave);
      section.removeEventListener('focusin', onFocusIn);
      section.removeEventListener('focusout', onFocusOut);
      section.removeEventListener('keydown', onKeydown);
      document.removeEventListener('visibilitychange', onVisibility);
      document.removeEventListener('shopify:block:select', onBlockSelect);
      document.removeEventListener('shopify:block:deselect', onBlockDeselect);
      if (previous) previous.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      if (toggle) toggle.removeEventListener('click', onToggle);
      dots.forEach(function (dot) { dot.removeEventListener('click', dot._kmClick); });
      instances.delete(section);
    }

    if (previous) previous.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    if (toggle) toggle.addEventListener('click', onToggle);
    dots.forEach(function (dot, dotIndex) {
      dot._kmClick = function () { manualMove(dotIndex); };
      dot.addEventListener('click', dot._kmClick);
    });
    section.addEventListener('mouseenter', onEnter);
    section.addEventListener('mouseleave', onLeave);
    section.addEventListener('focusin', onFocusIn);
    section.addEventListener('focusout', onFocusOut);
    section.addEventListener('keydown', onKeydown);
    document.addEventListener('visibilitychange', onVisibility);
    document.addEventListener('shopify:block:select', onBlockSelect);
    document.addEventListener('shopify:block:deselect', onBlockDeselect);
    instances.set(section, { destroy: destroy });
    paint(index, false, false);
    startTimer();
  }

  function initAll(root) {
    var scope = root || document;
    if (scope.matches && scope.matches('[data-km-blog-hero]')) init(scope);
    scope.querySelectorAll('[data-km-blog-hero]').forEach(init);
  }
  function cleanup(section) {
    if (!section) return;
    var instance = instances.get(section);
    if (instance) instance.destroy();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  else initAll(document);
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target.matches && event.target.matches('[data-km-blog-hero]') ? event.target : event.target.querySelector('[data-km-blog-hero]');
    cleanup(section);
  });
})();
